import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export function ModalAgreeLocation({ isOpen, fromRenovarPage, validarClienteDentroColombia, toggleStateModalUserOutColombia }) {
    const [open, setOpen] = useState(isOpen);


    const handleClose = (e, r) => {
        if (r === 'backdropClick') {
            return
        }
        setOpen(false);
    };

    const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
    };

    const success = (pos) => {
        const crd = pos.coords;
        if (crd.latitude && crd.longitude) {
            console.log('Your current position is:');
            console.log(`Latitude : ${crd.latitude}`);
            console.log(`Longitude: ${crd.longitude}`);
            console.log(`More or less ${crd.accuracy} meters.`);
            localStorage.setItem('coords', JSON.stringify({ lat: crd.latitude, lon: crd.longitude }));
            if (fromRenovarPage) {
                validarClienteDentroColombia({ lat: crd.latitude, lon: crd.longitude })
                    .then((hasInColombia) => {
                        toggleStateModalUserOutColombia(hasInColombia === false ? true : false);
                    })
                    .catch(e => console.log(e))
            }
            handleClose();
        } else {
            console.log('No se logró encontrar la posición del usuario');
            //4.661695 -74.070759
            localStorage.setItem('coords', JSON.stringify({ lat: "4.661695", lon: "-74.070759" }));
            handleClose();
        }
    }

    function error(err) {
        console.warn(`ERROR(${err.code}): ${err.message}`);
        localStorage.setItem('coords', JSON.stringify({ lat: "4.661695", lon: "-74.070759" }));
        handleClose();
    }

    const askedPermissionLocate = () => {
        navigator.geolocation.getCurrentPosition(success, error, options)
    }

    return (
        <div>
            <Dialog
                disableEscapeKeyDown={true}
                open={open}
                onClose={(e, r) => handleClose(e, r)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Este paso es obligatorio!"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Para seguir adelante con el proceso es importante aceptar la activación de geolocalización, con esto ayudas a proteger la seguridad de tu identidad.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={askedPermissionLocate} autoFocus>
                        Acepto
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}